import { render, staticRenderFns } from "./ItemMeta.vue?vue&type=template&id=040ee6d4&"
import script from "./ItemMeta.vue?vue&type=script&lang=js&"
export * from "./ItemMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports